import React from 'react'
import WithdrawInfoPopup from '@bet25/ui/WithdrawInfoPopup'
import { ModalService } from 'services/ModalService'

const InfoPopup = ({ data }) => {
    const { amount, popupType } = data

    const onCloseModal = () => {
        ModalService.closeModal()
        setTimeout(() => {
            ModalService.showModal('USER_AREA')
        }, 100)
    }

    const onReadMore = () => {
        setTimeout(() => {
            ModalService.showModal('WITHDRAW_READ_MORE')
        }, 100)
    }

    return (
        <WithdrawInfoPopup
            currentTheme={'dark'}
            onCloseModal={onCloseModal}
            onConfirm={onCloseModal}
            onReadMore={onReadMore}
            amount={amount}
            popupType={popupType}
        />
    )
}

export default InfoPopup
